import { Base } from "../../framework/base";
import { FileAttachment, IFileAttachment } from "../common/fileAttachment";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IWhistleBlowEditItemMessage {
    id: string;
    date: number;
    content: string;
    isInternal: boolean;
    myMessage: boolean;
    informantMessage: boolean;
    allRead: boolean;
    isRead: boolean;
    modifyUser: IModifyUser;
    attachments: IFileAttachment[];
}

export class WhistleBlowEditItemMessage implements IWhistleBlowEditItemMessage {
    id: string;
    date: number;
    content: string;
    isInternal: boolean;
    informantMessage: boolean;
    myMessage: boolean;
    allRead: boolean;
    isRead: boolean;
    modifyUser: ModifyUser;
    attachments: FileAttachment[];

    constructor();
    constructor(obj: IWhistleBlowEditItemMessage);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.date = obj && obj.date || 0;
        this.content = obj && obj.content || "";
        this.isInternal = obj && obj.isInternal || false;
        this.myMessage = obj && obj.myMessage || false;
        this.informantMessage = obj && obj.informantMessage || false;
        this.allRead = obj && obj.allRead || false;
        this.isRead = obj && obj.isRead || false;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
    }
        
    static sortWhistleBlowEditItemMessages(items: IWhistleBlowEditItemMessage[]): IWhistleBlowEditItemMessage[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IWhistleBlowEditItemMessage, b: IWhistleBlowEditItemMessage) => { return (!a || !b) ? 0 : Base.numCompare(a.date, b.date); });
    }
}